import { Tooltip, TooltipProps } from '@swaggerhub-portal/component-library'
import { InfoNotificationMobile } from 'app/components/TooltipWrapper/InfoNotificationMobile'
import { useMediaQuery } from 'usehooks-ts'

import appDefaults from '~/app.defaults.json'

export type TooltipWrapperProps = TooltipProps & {
  displayOnMobile?: boolean;
}

export const TooltipWrapper = ({
  displayOnMobile = false,
  ...props
}: TooltipWrapperProps) => {
  const isMobile = useMediaQuery(appDefaults.media.mobile, { initializeWithValue: false })

  if (isMobile) {
    const {
      defaultComp,
      content,
      disabled, 
      'aria-label': ariaLabel
    } = props

    return (
      <InfoNotificationMobile
        content={content}
        defaultComp={defaultComp instanceof Function ? defaultComp({ ref: null, overflowed: false }) : defaultComp}
        visible={displayOnMobile}
        disabled={disabled}
        aria-label={ariaLabel}
      />
    )
  }

  return (
    <Tooltip {...props} />
  )
}